"use client"

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { format } from "date-fns"

interface Prescription {
  id: string;
  created_at: string;
  medication_name: string;
  dosage: string | null;
  frequency: string | null;
  duration: string | null;
  notes: string | null;
  appointments: {
      appointment_date: string;
  } | null;
}

interface PrescriptionsHistoryTabProps {
  prescriptions: Prescription[];
}

export function PrescriptionsHistoryTab({ prescriptions }: PrescriptionsHistoryTabProps) {
  if (!prescriptions || prescriptions.length === 0) {
    return <p className="text-center text-muted-foreground mt-4">No prescription history found.</p>
  }
  
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Prescribed On</TableHead>
            <TableHead>Medication</TableHead>
            <TableHead>Dosage</TableHead>
            <TableHead>Frequency</TableHead>
            <TableHead>Duration</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {prescriptions.map((p) => (
            <TableRow key={p.id}>
              <TableCell>{format(new Date(p.created_at), "PPP")}</TableCell>
              <TableCell>
                <div className="font-medium">{p.medication_name}</div>
                {p.notes && <div className="text-xs text-muted-foreground">{p.notes}</div>}
              </TableCell>
              <TableCell>{p.dosage || 'N/A'}</TableCell>
              <TableCell>{p.frequency || 'N/A'}</TableCell>
              <TableCell>{p.duration || 'N/A'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
} 